import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogTitle } from "src/components/base/dialog";
import { Button } from "../base/button";
import { FullSplitDnsResolver } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";
import { toast } from "react-toastify";

/**
 * The properties for {@link DeleteResolverDialog}
 */
export type DeleteResolverDialogProps = {
    /** The Resolver */
    resolver: FullSplitDnsResolver;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful deletion */
    onDeletion: () => void;
};

/**
 * A dialog to delete a resolver
 */
export default function DeleteResolverDialog(props: DeleteResolverDialogProps) {
    const [t] = useTranslation("dialog-delete-split-dns");

    /**
     * Delete a resolver
     */
    const deleteResolver = async () => {
        await ApiInternal.dns.deleteResolverSplitDns(props.resolver.uuid);
        toast.success(t("toast.successfully-deleted-resolver"));
        props.onDeletion();
    };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("heading.delete-resolver")}</DialogTitle>
            <DialogActions>
                <Button autoFocus={true} onClick={props.onClose}>
                    {t("button.cancel")}
                </Button>
                <Button color={"red"} onClick={async () => await deleteResolver()}>
                    {t("button.delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
